import { Link, useNavigate } from "react-router-dom";
import { BsCreditCard, BsGear, BsQuestionCircle } from "react-icons/bs";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { isEmailVerified } from "../../../utils/authHelpers";
import { FiLock, FiLogOut } from "react-icons/fi";
import { FaPencil } from "react-icons/fa6";

const ProfileNav = ({ handleLogout }: { handleLogout: () => void }) => {
  const navigate = useNavigate();
  const verifyEmail = () => {
    navigate("/verify-email");
  };

  return (
    <nav className="w-full flex flex-col items-start">
      <div className="flex flex-col gap-6 w-full py-6 text-gray-7 font-medium text-2xl">
        <Link to="/profile/edit" className="flex items-center gap-4">
          <FaPencil /> Edit Profile
        </Link>
        <Link to="/profile/settings" className="flex items-center gap-4">
          <BsGear /> Settings
        </Link>
        <Link to="/profile/password-change" className="flex items-center gap-4">
          <FiLock /> Change Password
        </Link>
        <Link to="/profile/subscription" className="flex items-center gap-4">
          <BsCreditCard /> Subscription
        </Link>
        {!isEmailVerified && (
          <a
            href="/profile/verify"
            onClick={verifyEmail}
            className="flex items-center gap-4"
          >
            <MdOutlineMarkEmailRead /> Verify E-mail
          </a>
        )}

        {/* <Link to="/profile/verify" className="flex items-center gap-4">
          <MdOutlineMarkEmailRead /> Verify E-mail
        </Link> */}
      </div>

      <div className="w-full  max-w-[calc(100%-64px)] xl:max-w-[920px] mx-auto border-b border-gray-2" />
      <div className="flex flex-col gap-6 w-full py-6 text-gray-7 font-medium text-2xl">
        <Link to="/profile/help" className="flex items-center gap-4">
          <BsQuestionCircle /> Help & Support
        </Link>
        <button className="flex items-center gap-4" onClick={handleLogout}>
          <FiLogOut /> Log Out
        </button>
      </div>
    </nav>
  );
};

export default ProfileNav;
